<template>
    <div class="contenedor-programacion-default">
        <v-container fluid>
            <v-card
                class="mb-4"
                flat>
                <v-card-text>
                <titulo-tool-bar></titulo-tool-bar>
                <tool-bar
                    class="mb-4"
                    v-on:nuevoOficio="registrarNuevoOficio"
                    :filtros="filtros"
                    :listaOficiosAutorizacion="getListaOficiosAutorizacion"
                    :ejercicio ="getEjercicio"
                    >
                </tool-bar>
                </v-card-text>
            </v-card>
            <v-card flat>
                <v-card-text>
                    <listado
                      :listadoOficiosAutorizacion="getListaOficiosAutorizacion"
                      :total="getTotalRegistros"
                      :totalAutorizaciones="getTotalAutorizaciones"
                      :totalCancelaciones="getTotalCancelaciones"
                      :importeTotal="getImporteTotal"
                      :cargando="$apollo.queries.filtrarOficiosAutorizacion.loading"
                      @actualizar-opciones="actualizarOpciones">
                    </listado>
                </v-card-text>
            </v-card>
        </v-container>
        <v-dialog
        persistent
        v-model="mostrarVentanaRegistrarNuevoOficio"
        :width="!$vuetify.breakpoint.mobile ? '80%' : '90%'">
          <registrar-nuevo-oficio
              v-if="mostrarVentanaRegistrarNuevoOficio"
              v-on:cerrar="cerrarRegistrarNuevoOficio">
          </registrar-nuevo-oficio>
        </v-dialog>
        <v-dialog
        v-if="oficioAutorizacionEditar"
        persistent
        v-model="mostrarVentanaEditarOficioAutorizacion"
        :width="!$vuetify.breakpoint.mobile ? '80%' : '90%'">
          <editar-oficio
              :oficioAutorizacionEditar="oficioAutorizacionEditar"
              v-on:cerrar="cerrarEditarOficio">
          </editar-oficio>
        </v-dialog>
        <v-dialog
        persistent
        v-model="mostrarVentanaEliminarOficioAutorizacionDetalle"
        width="450">
          <eliminar-detalle
            :oficioAutorizacionDetalleEliminar="oficioAutorizacionDetalleEliminar"
            v-on:cerrar="cerrarEliminarOficioDetalle"
          >
          </eliminar-detalle>
        </v-dialog>
        <v-dialog
        persistent
        v-model="mostrarVentanaEliminarOficioAutorizacion"
        width="450">
          <eliminar-oficio
          :oficioAutorizacionEliminar="oficioAutorizacionEliminar"
          v-on:cerrar="cerrarEliminarOficio">

          </eliminar-oficio>

        </v-dialog>
    </div>
</template>
<script>
import OFICIOS_AUTORIZACION from '@/graphql/querys/administracion/programacion/oficiosautorizacion/oficiosautorizacion.gql';
import TituloToolBar from '@/views/administracion/programacion/TituloToolBar.vue';
import ToolBar from '@/views/administracion/programacion/ToolBar.vue';
import Listado from '@/views/administracion/programacion/listado/Main.vue';
import RegistrarNuevoOficio from '@/components/administracion/programacion/oficiosautorizacion/Nuevo.vue';
import EliminarDetalle from '@/components/administracion/programacion/oficiosautorizacion/oficiosautorizaciondetalle/Eliminar.vue';
import EliminarOficio from '@/components/administracion/programacion/oficiosautorizacion/Eliminar.vue';
import EditarOficio from '@/components/administracion/programacion/oficiosautorizacion/Editar.vue';
import eventBus from '@/helpers/eventBus';
import mixFormatoEstructura from '@/helpers/mixFormatoEstructura';

export default {
  name: 'ProgramacionDefault',
  mixins: [mixFormatoEstructura],
  components: {
    TituloToolBar,
    ToolBar,
    Listado,
    RegistrarNuevoOficio,
    EliminarDetalle,
    EliminarOficio,
    EditarOficio,
  },
  data() {
    return {
      mostrarVentanaRegistrarNuevoOficio: false,
      mostrarVentanaEditarOficioAutorizacion: false,
      mostrarVentanaEliminarOficioAutorizacionDetalle: false,
      mostrarVentanaEliminarOficioAutorizacion: false,
      oficioAutorizacionDetalleEliminar: {},
      oficioAutorizacionEliminar: {},
      oficioAutorizacionEditar: {},
      filtros: {
        ejercicio: new Date().getFullYear(),
        buscar: '',
        limite: 15,
        pagina: 1,
        ordenarPor: 'fecha',
        direccion: 'DESC',
      },
    };
  },
  created() {
    // Leer query params de la URL al inicializar
    this.leerQueryParams();
  },
  apollo: {
    filtrarOficiosAutorizacion: {
      query: OFICIOS_AUTORIZACION,
      variables() {
        return {
          filtros: {
            ejercicio: this.filtros.ejercicio,
            buscar: this.filtros.buscar || null,
            limite: this.filtros.limite,
            pagina: this.filtros.pagina,
            ordenarPor: this.filtros.ordenarPor,
            direccion: this.filtros.direccion,
          },
        };
      },
      fetchPolicy: 'cache-and-network',
    },
  },
  mounted() {
    eventBus.$on('eliminar-oficio-autorizacion-detalle', (oficioAutorizacionDetalle) => {
      this.oficioAutorizacionDetalleEliminar = oficioAutorizacionDetalle;
      this.mostrarVentanaEliminarOficioAutorizacionDetalle = true;
    });
    eventBus.$on('eliminar-oficio-autorizacion', (oficioAutorizacion) => {
      this.oficioAutorizacionEliminar = oficioAutorizacion;
      this.mostrarVentanaEliminarOficioAutorizacion = true;
    });
    eventBus.$on('editar-oficio-autorizacion', (oficioAutorizacion) => {
      this.oficioAutorizacionEditar = oficioAutorizacion;
      this.mostrarVentanaEditarOficioAutorizacion = true;
    });
  },
  watch: {
    filtros: {
      handler() {
        this.actualizarQueryParams();
      },
      deep: true,
    },
    // Escuchar cambios en la ruta (por ejemplo, al usar back/forward)
    '$route.query': {
      handler() {
        this.leerQueryParams();
      },
      deep: true,
    },
  },
  computed: {
    getEjercicio() {
      if (!this.getListaOficiosAutorizacion || this.getListaOficiosAutorizacion.length === 0) return '';
      return this.getListaOficiosAutorizacion[0].ejercicio.toString();
    },
    getOficiosAutorizacion() {
      if (!this.filtrarOficiosAutorizacion) return [];
      return this.filtrarOficiosAutorizacion;
    },
    getListaOficiosAutorizacion() {
      if (!this.filtrarOficiosAutorizacion?.datos) return [];
      return this.filtrarOficiosAutorizacion.datos.map((oficio) => ({
        ...oficio,
        ejercicio: new Date(`${oficio.fecha} 00:00:00`).getFullYear(),
        vencido: new Date(oficio.fechaVencimiento) > new Date(),
      }));
    },
    getTotalRegistros() {
      return this.filtrarOficiosAutorizacion?.total || 0;
    },
    getTotalAutorizaciones() {
      return this.filtrarOficiosAutorizacion?.totalAutorizaciones || 0;
    },
    getTotalCancelaciones() {
      return this.filtrarOficiosAutorizacion?.totalCancelaciones || 0;
    },
    getImporteTotal() {
      return this.filtrarOficiosAutorizacion?.importeTotal || 0;
    },
  },
  methods: {
    leerQueryParams() {
      const { query } = this.$route;
      // Solo actualizar si hay diferencias para evitar loops
      const nuevosFiltros = {
        ejercicio: query.ejercicio
          ? parseInt(query.ejercicio, 10)
          : new Date().getFullYear(),
        buscar: query.buscar || '',
        limite: query.limite ? parseInt(query.limite, 10) : 15,
        pagina: query.pagina ? parseInt(query.pagina, 10) : 1,
        ordenarPor: query.ordenarPor || 'fecha',
        direccion: query.direccion || 'DESC',
      };

      // Comparar y actualizar solo si hay diferencias
      if (JSON.stringify(this.filtros) !== JSON.stringify(nuevosFiltros)) {
        this.filtros = nuevosFiltros;
      }
    },
    actualizarQueryParams() {
      const queryActual = this.$route.query;
      const nuevaQuery = {
        ejercicio: this.filtros.ejercicio.toString(),
        buscar: this.filtros.buscar || undefined,
        limite: this.filtros.limite.toString(),
        pagina: this.filtros.pagina.toString(),
        ordenarPor: this.filtros.ordenarPor,
        direccion: this.filtros.direccion,
      };

      // Limpiar valores undefined/vacíos
      Object.keys(nuevaQuery).forEach((key) => {
        if (nuevaQuery[key] === undefined || nuevaQuery[key] === '') {
          delete nuevaQuery[key];
        }
      });

      // Solo actualizar si hay diferencias
      if (JSON.stringify(queryActual) !== JSON.stringify(nuevaQuery)) {
        this.$router.replace({ query: nuevaQuery }).catch(() => {});
      }
    },
    actualizarOpciones(opciones) {
      this.filtros.pagina = opciones.pagina;
      this.filtros.limite = opciones.limite;
      this.filtros.ordenarPor = opciones.ordenarPor;
      this.filtros.direccion = opciones.direccion;
    },
    registrarNuevoOficio() {
      this.mostrarVentanaRegistrarNuevoOficio = true;
    },
    cerrarRegistrarNuevoOficio() {
      this.mostrarVentanaRegistrarNuevoOficio = false;
    },
    cerrarEliminarOficioDetalle() {
      this.mostrarVentanaEliminarOficioAutorizacionDetalle = false;
    },
    cerrarEliminarOficio() {
      this.mostrarVentanaEliminarOficioAutorizacion = false;
    },
    cerrarEditarOficio() {
      this.mostrarVentanaEditarOficioAutorizacion = false;
      this.oficioAutorizacionEditar = null;
    },
  },
};
</script>
